import { UserEntity } from '@core/entities';
import { combineLatest } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ClubDatesFilter } from '@core/enums';
import { UseClub } from '@core/usecases';

@UntilDestroy()
export class ClubDatesComposition {
  isLoading = false;
  users: UserEntity[] = [];

  private _birthdays: UserEntity[] = [];
  private _jubilees: UserEntity[];
  private readonly _useClub = new UseClub();

  onFilterChange(filter: ClubDatesFilter) {
    switch (filter) {
      case ClubDatesFilter.AllImportantDates:
        this._fetchAllClubDates();
        break;
      case ClubDatesFilter.Birthdays:
        this.users = this._sortArrayByDate(this._birthdays);
        break;
      case ClubDatesFilter.Jubilees:
        this.users = this._sortArrayByDate(this._jubilees);
        break;
    }
  }

  // ---------------------------------------------------------------------------------------------------------------------
  // ------------------------------------------ Private Protected Functions ----------------------------------------------
  // ---------------------------------------------------------------------------------------------------------------------

  protected _fetchAllClubDates() {
    this.isLoading = true;
    combineLatest([this._useClub.getUpcomingBirthdays(), this._useClub.getUpcomingJubilees()])
      .pipe(untilDestroyed(this))
      .subscribe({
        next: ([birthdays, jubilees]) => {
          this._birthdays = birthdays;
          this._jubilees = jubilees;
          this.users = this._sortArrayByDate(this._birthdays.concat(this._jubilees));
          this.isLoading = false;
        },
      });
  }

  private _sortArrayByDate(array: UserEntity[]) {
    return array.sort((a, b) => {
      const dayA = new Date(a.bdNotification).getDate();
      const dayB = new Date(b.bdNotification).getDate();
      return dayA - dayB;
    });
  }
}
